import { Alert, Box, Link, Stack, Typography } from "@mui/material";

import { useCohortDetails } from "./useCohortDetails";

type MemberWithNote = {
  id: string;
  tierIIReportId: string;
  fulfillmentNote: string;
  facilityName: string;
};

export function CohortFulfillmentNotes() {
  const { data } = useCohortDetails();

  const membersWithNotes: MemberWithNote[] = (data?.cohort?.members ?? [])
    .filter(
      (
        member
      ): member is typeof member & {
        tierIIReport: { fulfillmentNote: string };
      } => Boolean(member.tierIIReport?.fulfillmentNote)
    )
    .map((member) => ({
      id: member.id,
      tierIIReportId: member.tierIIReport.id,
      fulfillmentNote: member.tierIIReport.fulfillmentNote,
      facilityName: member.facility?.name ?? "Unknown Facility",
    }))
    .sort((a, b) => a.facilityName.localeCompare(b.facilityName));

  if (membersWithNotes.length === 0) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      icon={false}
      sx={{
        p: 2,
        width: "100%",
        "& .MuiAlert-message": {
          width: "100%",
          padding: 0,
        },
      }}
    >
      <Stack spacing={2}>
        <Stack direction="row" spacing={1} alignItems="center">
          <span role="img" aria-label="pin">
            📌
          </span>
          <Typography variant="h6">Fulfillment Notes from Members</Typography>
        </Stack>

        <Box component="ul" sx={{ m: 0, pl: 3 }}>
          {membersWithNotes.map((member) => (
            <Box component="li" key={member.id} sx={{ mb: 1 }}>
              <Typography variant="body2">
                <Link
                  href={`/staff/fulfillment/r/${member.tierIIReportId}`}
                  sx={{ fontWeight: "bold" }}
                >
                  {member.facilityName}
                </Link>
                : {member.fulfillmentNote}
              </Typography>
            </Box>
          ))}
        </Box>
      </Stack>
    </Alert>
  );
}
